<div class="page-content fade-in-up">
  <br>
  <!-- <div class="row">
    <div class="col-3">
      <button style="margin-left:0.5%;" class="btn btn-link" (click)="back()"><i class="fa fa-arrow-left"
          aria-hidden="true"></i> Go Back</button>
    </div>
  </div> -->
  <div class="row">

    <div class="col-lg-12 col-md-12">

      <div class="ibox" style="box-shadow: none !important;background-color: white !important;">
        <div class="ibox-head">
          <div class="ibox-title">{{mainService.allLableShowObj[mainService.language_cd+'PORTALACCOUNT1']}}
          </div>
        </div>
        <div class="ibox-body">
          <ul class="nav nav-tabs tabs-line">
            <li class="nav-item">
              <a class="nav-link active" href="#tab-1" data-toggle="tab"><i
                  class="ti-bar-chart"></i>{{mainService.allLableShowObj[mainService.language_cd+'PORTALACCOUNT2']}}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#tab-2" data-toggle="tab"><i
                  class="ti-settings"></i>{{mainService.allLableShowObj[mainService.language_cd+'PORTALACCOUNT3']}}</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#tab-4" data-toggle="tab"><i
                  class="ti-announcement"></i>{{mainService.allLableShowObj[mainService.language_cd+'PORTALACCOUNT4']}}
              </a>
            </li>
            <li class="nav-item back-btn-tab">

              <button class="btn btn-link fs-5" style="box-shadow: none !important;" (click)="back()"><i
                  class="fa fa-arrow-left" aria-hidden="true"></i> Go Back</button>
            </li>

          </ul>
          <div class="tab-content">
            <div class="tab-pane fade show active" id="tab-1">
              <div class="profile-tab-container white-bg-centered">
                <div class="profile-image-wrapper">
                  <img [src]="imgURL" class="profile-img" />
                </div>

                <div class="profile-field-line">
                  <span class="profile-label">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT5'] }} :
                  </span>
                  <span class="profile-value">
                    {{ mainService.accInfo['b_acct_id'] }}
                  </span>
                </div>

                <div class="profile-field-line">
                  <span class="profile-label">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT6'] }} :
                  </span>
                  <span class="profile-value">
                    {{ mainService.accInfo['account_name'] }} ({{ mainService.accInfo['account_short_name'] }})
                  </span>
                </div>

                <div class="profile-field-line">
                  <span class="profile-label">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT7'] }} :
                  </span>
                  <span class="profile-value">
                    {{ mainService.accInfo['address'] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="tab-2">
              <div class="profile-tab-container white-bg-centered">
                <h5 class="text-center mb-4">Update Profile</h5>

                <div class="profile-field-lines">
                  <label class="profile-labels">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT8'] }} :
                  </label>
                  <input class="form-control w-50" [(ngModel)]="updateObj['account_short_name']">
                </div>

                <div class="profile-field-lines">
                  <label class="profile-labels">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT6'] }} :
                  </label>
                  <input class="form-control w-50" [(ngModel)]="updateObj['account_name']">
                </div>

                <div class="profile-field-lines">
                  <label class="profile-labels">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT7'] }} :
                  </label>
                  <textarea class="form-control w-50" [(ngModel)]="updateObj['address']"></textarea>
                </div>

                <div class="text-center mt-4">
                  <button class="btn btn-primary" (click)="updateAccInfo()">
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT9'] }}
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="tab-4">
              <div class="profile-tab-container white-bg-centered">
                <div class="profile-image-wrapper">
                  <img [src]="imgURL" class="profile-img" />
                </div>

                <div class="profile-field-line">
                  <input #file type="file" accept=".png, .jpg, .jpeg" name="pimage" ng2FileSelect [uploader]="uploader"
                    class="form-control w-75" (change)="onFileUpload($event, file.files)" />
                </div>

                <div class="text-center mt-3">
                  <button type="button" [disabled]="!uploader.getNotUploadedItems().length" class="btn btn-info"
                    (click)="Upload()">
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    {{ mainService.allLableShowObj[mainService.language_cd + 'PORTALACCOUNT10'] }}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <style type="text/css">
    .profile-social a {
      font-size: 16px;
      margin: 0 10px;
      color: #999;
    }

    .profile-social a:hover {
      color: #485b6f;
    }

    .profile-stat-count {
      font-size: 22px
    }
  </style>


  <div class="row">
    <div class="col-12 text-center">
      <!-- <div class="font-13">build=erpbuild</div> -->
    </div>
  </div>
</div>
<ngx-spinner>Loading...</ngx-spinner>